module.exports = __webpack_public_path__ + "static/media/5_BC.44687347.jpg";